import React, { useEffect, useState } from 'react';
import PurchaseOrderFieldCustomisation from './components/purchaseOrderFieldCustomisation';
import Button from '../../../../../component/ui/Button';
import PurchaseOrderGeneral from './components/purchaseOrderGeneral';
import { stringToBool } from '../../../../../utils/utility';
import { getPOGeneral, UpdatePOGeneral } from '../../../../../services/settings/purchases';
import { toast } from 'react-toastify';

export default function SettingsPurchaseOrder({ activeTab }) {
	const [tab, setTab] = useState('General');
	const [isEdit, setIsEdit] = useState(false);
	const [isCreateForm, setIsCreateForm] = useState(false);
	const [poLoader, setPOLoader] = useState({
		isLoader: true,
		isSave: false,
		isGetData: true,
		isGetDataFieldCustomisation: true,
		isSaveFieldCustomisation: true,
	});
	const [customFieldError, setCustomFieldError] = useState(false);
	const [error, setError] = useState(false);
	const [customFieldForm, setCustomFieldForm] = useState({
		label_name: '',
		data_type: '',
		status: false,
		is_mandatory: false,
	});
	const [generalForm, setGeneralForm] = useState({});
	const [form, setForm] = useState({});

	const handlePOGeneral = async () => {
		try {
			setPOLoader((prev) => ({
				...prev,
				isLoader: true,
				isSave: true,
			}));
			setIsEdit(false);
			const res = await UpdatePOGeneral(form);
			if (res.success) {
				toast.success(res.message);
				getGeneralDetail();
			} else {
				setIsEdit(true);
				toast.error(res.message);
			}
		} catch (error) {
			setIsEdit(true);
		} finally {
			setPOLoader((prev) => ({
				...prev,
				isLoader: false,
				isSave: false,
			}));
		}
	};
	const handleCustomField = () => {};

	const getShowUndoChanged = () => {
		const hasChanged = JSON.stringify(generalForm) !== JSON.stringify(form);
		setIsEdit(hasChanged);
	};

	useEffect(() => {
		if (form) {
			getShowUndoChanged();
		}
	}, [form]);

	const getGeneralDetail = async () => {
		try {
			setPOLoader((prev) => ({
				...prev,
				isLoader: true,
				isGetData: true,
			}));
			const { purchase_order_settings } = await getPOGeneral();
			var data = {
				enable_auto_create_purchase_order:
					purchase_order_settings.enable_auto_create_purchase_order !== null
						? stringToBool(purchase_order_settings.enable_auto_create_purchase_order)
						: false,
				terms_and_conditions: purchase_order_settings.terms_and_conditions || '',
				customer_notes: purchase_order_settings.customer_notes || '',
			};
			setForm(data);
			setGeneralForm(data);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setPOLoader((prev) => ({
				...prev,
				isLoader: false,
				isGetData: false,
			}));
		}
	};

	useEffect(() => {
		if (tab === 'General') {
			getGeneralDetail();
		} else if (tab === 'Field Customisation') {
		}
	}, [tab]);

	return (
		<div>
			<div style={{ backgroundColor: '#EDEDF7', position: 'sticky', top: 0, zIndex: 100 }}>
				<div className="d-flex py-3 px-2 justify-content-between align-items-center">
					<div className="fs-4 fw-semibold">{activeTab}</div>
					<div className="d-flex gap-3">
						{tab === 'Field Customisation' ? (
							<Button
								type="button"
								className="mt-0 btn-primary fs-5 fw-light add-pro py-1"
								button="Add New Custom Field"
								add
								onClick={() => setIsCreateForm(true)}
							/>
						) : (
							<>
								<Button
									type="button"
									className="btn-primary mt-0 fs-5 fw-light add-pro py-1 px-4"
									button="Save"
									disabled={!isEdit}
									onClick={() => handlePOGeneral()}
									loader={poLoader.isLoader && poLoader.isSave}
								/>
								{isEdit && (
									<Button
										type="button"
										className="btn-primary mt-0 fs-5 fw-light add-pro py-1 px-4"
										button="Undo Changed"
										onClick={() => {
											setIsEdit(false);
											getGeneralDetail();
										}}
									/>
								)}
							</>
						)}
					</div>
				</div>
			</div>
			<div
				className="py-2 d-flex justify-content-between align-items-center"
				style={{ backgroundColor: '#DADDEC', position: 'sticky', top: 0, zIndex: 100 }}
			>
				<div>
					<ul className="nav mt-2">
						{['General', 'Field Customisation'].map((item, index) => (
							<li
								key={index}
								className="nav-item"
							>
								<div
									className={`tab-link ${tab === item ? 'active' : ''} d-flex align-items-center`}
									onClick={() => {
										setTab(item);
										setIsCreateForm(false);
									}}
								>
									{item}
								</div>
							</li>
						))}
					</ul>
				</div>
				{isCreateForm && (
					<div className="d-flex gap-4 align-items-center px-2">
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#0066ff' }}
							onClick={() => handleCustomField()}
						>
							Save
						</div>
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#555B67' }}
							onClick={() => setIsCreateForm(false)}
						>
							Cancel
						</div>
					</div>
				)}
			</div>
			{tab === 'General' ? (
				<PurchaseOrderGeneral
					form={form}
					setForm={setForm}
					error={error}
					setError={setError}
					poLoader={poLoader}
				/>
			) : (
				<PurchaseOrderFieldCustomisation
					isCreateForm={isCreateForm}
					setIsCreateForm={setIsCreateForm}
					setCustomFieldForm={setCustomFieldForm}
					customFieldForm={customFieldForm}
					setCustomFieldError={setCustomFieldError}
					customFieldError={customFieldError}
				/>
			)}
		</div>
	);
}
